// Owns the on-demand search entry; the search view owns input and discovery results.
/** Open one canonical search surface. Blank drafts lead to suggestions rather than
 * a second empty popover; opening search does not perform an invalid text search. */
export function bindHeaderSearch(ctx) {
  const trigger = document.querySelector('#search-toggle');
  const draft = document.querySelector('#search');
  trigger.addEventListener('click', () => {
    ctx.query = draft.value.trim();
    ctx.go('search');
  });
}
